export default __webpack_public_path__ + "assets/414534af074eb1d3360105b35feea14d.ttf";